import { type QueryObserverOptions, useQuery } from '@tanstack/react-query';
import { getOrgTitles } from '@/api/Terminal/OrgTitle';
import type { GetOrgTitlesServiceRes } from '@/api/Terminal/OrgTitle/types';
import { ReactQueryKey } from '@/constants/ReactQueryKeys';
import type { QueryParamsInterface } from '@/types/Shared';

export const useOrgTitles = ({
  onSuccess,
  onError,
  params,
  ...options
}: {
  params?: QueryParamsInterface;
} & QueryObserverOptions<GetOrgTitlesServiceRes>) => {
  return useQuery<GetOrgTitlesServiceRes>(
    [ReactQueryKey.GET_ORG_TITLES, params],
    () => getOrgTitles({ order: 'asc', orderBy: 'name', ...params }),
    {
      ...options,
      keepPreviousData: true,
      staleTime: 30000,
    }
  );
};

export const useTitleById = (id?: number) => {
  const accountTitles = useOrgTitles({});

  const matchedTitle = accountTitles?.data?.data?.find((title) => title.id === id);

  const getTitle = (id: number) => {
    const matchedTitle = accountTitles?.data?.data?.find((title) => title.id === id);
    return matchedTitle;
  };

  return { matchedTitle, getTitle };
};

export const useTitleByName = (name?: string) => {
  const accountTitles = useOrgTitles({});

  const matchedTitle = accountTitles?.data?.data?.find((title) => title.name === name);

  const getTitle = (name: string) => {
    const matchedTitle = accountTitles?.data?.data?.find((title) => title.name === name.trim());
    return matchedTitle;
  };

  return { matchedTitle, getTitle };
};
